<template>
  <v-container>
    <!-- 頂部操作列 -->
    <div class="d-flex align-center mb-6">
      <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="輸入病患分類或病患名稱" outlined dense
        hide-details class="flex-grow-1 mr-4"></v-text-field>

      <v-btn color="black" dark class="mr-2" @click="isEditingTag = true">
        編輯病患
      </v-btn>
      <v-btn v-if="false" color="black" dark class="mr-2" @click="showAddDialog = true">
        新增分類
      </v-btn>
      <v-btn v-if="false" color="black" dark class="mr-2" @click="openDeleteConfirm()">
        刪除分類
      </v-btn>

      <v-btn v-if="isEditingTag" color="black" dark class="mr-2" @click="isEditingTag = false">
        完成
      </v-btn>

      <v-btn v-if="!isEditingTag" color="black" dark @click="addPatient">
        新增虛擬病患
      </v-btn>
    </div>

    <!-- 科別分類與病患列表 -->
    <div v-for="(patientCategory, index) in filteredPatientCategories" :key="index">
      <div class="d-flex align-center my-4">
        <!-- <v-checkbox
          v-if="isEditingTag"
          v-model="selectedPatientCategories"
          :value="patientCategory._id"
          class=""
        ></v-checkbox> -->
        <div class="text-h6 font-weight-bold text-left">{{ patientCategory.topicName }}</div>
        <v-divider class="flex-grow-1 ml-2"></v-divider>
      </div>
      <v-row v-if="patientCategory.patients && patientCategory.patients.length">
        <v-col v-for="patient in patientCategory.patients" :key="patient._id" cols="12" sm="6" md="3">
          <v-card class="patient-card" dark :class="{ 'selected': selectedPatient === patient }">
            <div class="patient-card-background" :style="{
              backgroundImage: patient.backgroundImage ? `url(${returnImageUrl(patient.backgroundImage)})` : '',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: 1
            }"></div>
            <v-card-text class="patient-card-content">
              <div class="d-flex justify-space-between">
                <v-icon small @click.stop="viewPracticeResults(patient)">mdi-eye</v-icon>
                <div class="d-flex align-center mr-4" v-if="isEditingTag">
                  <v-icon small @click="editPatient(patient)">mdi-pencil</v-icon>
                  <v-icon small @click="deletePatient(patient)">mdi-delete</v-icon>
                </div>
                <v-switch v-if="!isEditingTag" v-model="patient.isActive" dense hide-details inset
                  class="patient-card-switch" @change="updatePatientStatus(patient._id, $event)"></v-switch>
              </div>
              <div class="patient-info">
                <div class="text-h6">{{ patient.name || '未命名' }}</div>
                <div>{{ patient.age || '?' }}歲, {{ patient.gender || '未指定' }}</div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <p class="text-center">此分類暫無患者</p>
        </v-col>
      </v-row>
    </div>

    <!-- 新增病患對話框 -->
    <v-dialog v-model="dialog" max-width="1000px" persistent>
      <v-card>
        <v-card-title class="text-h6">
          {{ isEditing ? '編輯虛擬病患' : '新增虛擬病患' }}
        </v-card-title>

        <v-tabs v-model="dialogData.activeTab" fixed-tabs>
          <v-tab v-for="(tab, index) in tabs" :key="index">
            {{ tab.title }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="dialogData.activeTab">
          <!-- 第一頁：選擇病例標籤 -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div class="text-h6 mb-4">請選擇病例標籤</div>
                <v-select v-model="dialogData.basicInfo.tagCategoryTopic" :items="tagCategoryTopics" item-text="name"
                  item-value="_id" label="術式主題" outlined style="width: 80%; margin: 0 auto;"></v-select>
                <v-row v-for="(tagCategory, index) in filteredTagsCategory" :key="index" class="mb-4 mr-4 ml-4">
                  <v-col cols="12">
                    <div class="d-flex align-center">
                      <div class="text-subtitle-1 font-weight-bold">{{ tagCategory.name }}</div>
                      <v-spacer></v-spacer>
                    </div>
                    <div class="d-flex flex-wrap mt-2">
                      <v-chip v-for="(tag, index) in tagCategory.tags" :key="index" class="mr-2 mb-2"
                        :color="dialogData.tags.includes(tag._id) ? 'black' : ''" @click="toggleTag(tag._id)" outlined>
                        {{ tag.name }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- 第二頁：基本資料 -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div class="text-h6 mb-4">請輸入基本資料</div>
                <div class="d-flex">
                  <!-- 左側圖片上傳區域 -->
                  <div class="upload-container">
                    <input type="file" ref="fileInput" style="display: none" accept="image/*"
                      @change="handleFileUpload">
                    <!-- 預覽圖片 -->
                    <v-img v-if="dialogData.basicInfo.image" :src="dialogData.basicInfo.image" class="preview-image"
                      cover></v-img>
                    <!-- 刪除圖片按鈕 -->
                    <v-btn v-if="dialogData.basicInfo.image" icon color="error"
                      class="bg-image-delete-btn" @click="removeBackgroundImage">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <!-- 按鈕容器 -->
                    <div class="button-container">
                      <v-btn class="mb-2 image-button" outlined color="white" @click="$refs.fileInput.click()">
                        {{ dialogData.basicInfo.image ? '重新上傳' : '上傳照片' }}
                      </v-btn>
                      <v-btn class="mb-2 image-button" outlined color="white">
                        AI 生成
                      </v-btn>
                    </div>
                  </div>

                  <!-- 右側表單 -->
                  <div class="flex-grow-1">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field v-model="dialogData.basicInfo.name" label="姓名" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select v-model="dialogData.basicInfo.gender" :items="['男', '女', '其他']" label="性別" outlined
                          dense></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          v-model="dialogData.basicInfo.language"
                          :items="languageOptions"
                          item-text="text"
                          item-value="value"
                          label="對話語言"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="dialogData.basicInfo.age" label="年齡" type="number" outlined dense :rules="[
                          v => (v !== null && v !== '') || '請輸入年齡',
                          v => (v >= 0 && v <= 100) || '年齡必須在0到100歲之間'
                        ]" min="0" max="100"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select v-if="false" v-model="dialogData.basicInfo.patientCategory" :items="patientCategorys"
                          label="分類" item-text="name" item-value="_id" return-object outlined dense></v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea v-model="dialogData.basicInfo.description" label="情境說明" outlined
                          rows="4"></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea v-model="dialogData.basicInfo.taskDescription" label="任務說明" outlined
                          rows="4"></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-btn block color="black" dark @click="generateAI">
                          AI 生成
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- 第三頁：面診題目 -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div class="d-flex align-center mb-4" style="justify-content: center;">
                  <div class="text-h6">設定面診題目</div>
                </div>

                <!-- 圖片上傳區域 -->
                <div class="mb-4">
                  <div class="d-flex align-center">
                    <v-file-input v-model="dialogData.questions.clinic.files" multiple chips outlined dense
                      prepend-icon="mdi-upload" class="flex-grow-1" hide-details label="選擇檔案" :show-size="true"
                      accept=".png,.jpg,.jpeg"></v-file-input>
                  </div>
                  <!-- 已上傳圖片 -->
                  <div v-if="isEditing && dialogData.questions.clinic.uploadedFiles.length > 0" class="mt-3">
                    <div class="subtitle-2 mb-2">已上傳圖片</div>
                    <div class="d-flex flex-wrap">
                      <div v-for="(image, index) in dialogData.questions.clinic.uploadedFiles" :key="'clinic-img-' + index"
                        class="uploaded-image-thumb mr-2 mb-2">
                        <v-img :src="returnImageUrlByType(image, 1)" width="100" height="100"
                          class="rounded" cover @click="showUploadedImageDialog(1, dialogData.questions.clinic.uploadedFiles, dialogData.basicInfo._id)"></v-img>
                        <v-btn icon x-small color="error" class="uploaded-image-delete-btn"
                          @click="confirmDeleteImage(1, image, 'clinic')">
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>

                <v-divider></v-divider>

                <!-- 問題列表 -->
                <div class="questions-container">
                  <div class="question-list">
                    <div v-for="(question, index) in dialogData.questions.clinic.list" :key="index"
                      class="question-item" :class="{ selected: dialogData.questions.clinic.selectedIndex === index }"
                      @click="selectQuestion('clinic', index)">
                      題目{{ index + 1 }}
                    </div>
                    <div class="d-flex mt-2" style="justify-content: center;">
                      <v-btn icon small @click="addQuestion('clinic')">
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn icon small class="ml-2"
                        @click="removeQuestion('clinic', dialogData.questions.clinic.selectedIndex)">
                        <v-icon small>mdi-minus</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div class="question-content flex-grow-1">
                    <v-text-field
                    v-model="dialogData.questions.clinic.list[dialogData.questions.clinic.selectedIndex].scoreTopic"
                    label="評分主題" outlined dense class="mb-4"></v-text-field>

                    <v-text-field
                      v-model="dialogData.questions.clinic.list[dialogData.questions.clinic.selectedIndex].title"
                      label="題目" outlined dense class="mb-4"></v-text-field>

                    <!-- 答案陣列區塊 -->
                    <div class="answer-array-section mt-4">
                      <div class="d-flex justify-space-between align-center mb-2">
                        <div class="subtitle-1">答案列表</div>
                        <v-btn small color="primary" @click="addAnswer('clinic')">
                          <v-icon small left>mdi-plus</v-icon>
                          新增答案
                        </v-btn>
                      </div>

                      <v-card v-for="(answer, index) in getCurrentQuestion('clinic').answerArray" 
                             :key="index" 
                             outlined 
                             class="mb-2 pa-2">
                        <div class="d-flex align-center justify-space-between mb-2">
                          <div class="subtitle-2">答案 {{ index + 1 }}</div>
                          <v-btn icon x-small @click="removeAnswer('clinic', index)">
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <v-text-field v-model="answer.answer" label="答案內容" outlined dense class="mb-2"></v-text-field>
                        <v-text-field v-model="answer.score" label="評分分數" outlined dense type="number" class="mb-2"></v-text-field>
                        <v-text-field v-model="answer.comment" label="評語" outlined dense class="mb-2"></v-text-field>
                      </v-card>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- 第四頁：初診題目 -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div class="d-flex align-center mb-4" style="justify-content: center;">
                  <div class="text-h6">設定初診題目</div>
                </div>

                <!-- 圖片上傳區域 -->
                <div class="mb-4">
                  <div class="d-flex align-center">
                    <v-file-input v-model="dialogData.questions.firstVisit.files" multiple chips outlined dense
                      prepend-icon="mdi-upload" class="flex-grow-1" hide-details label="選擇檔案" :show-size="true"
                      accept=".png,.jpg,.jpeg"></v-file-input>
                  </div>
                  <!-- 已上傳圖片 -->
                  <div v-if="isEditing && dialogData.questions.firstVisit.uploadedFiles.length > 0" class="mt-3">
                    <div class="subtitle-2 mb-2">已上傳圖片</div>
                    <div class="d-flex flex-wrap">
                      <div v-for="(image, index) in dialogData.questions.firstVisit.uploadedFiles" :key="'fv-img-' + index"
                        class="uploaded-image-thumb mr-2 mb-2">
                        <v-img :src="returnImageUrlByType(image, 2)" width="100" height="100"
                          class="rounded" cover @click="showUploadedImageDialog(2, dialogData.questions.firstVisit.uploadedFiles, dialogData.basicInfo._id)"></v-img>
                        <v-btn icon x-small color="error" class="uploaded-image-delete-btn"
                          @click="confirmDeleteImage(2, image, 'firstVisit')">
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>

                <v-divider></v-divider>
                <!-- 問題列表 -->
                <div class="questions-container">
                  <div class="question-list">
                    <div v-for="(question, index) in dialogData.questions.firstVisit.list" :key="index"
                      class="question-item"
                      :class="{ selected: dialogData.questions.firstVisit.selectedIndex === index }"
                      @click="selectQuestion('firstVisit', index)">
                      題目{{ index + 1 }}
                    </div>
                    <div class="d-flex mt-2" style="justify-content: center;">
                      <v-btn icon small @click="addQuestion('firstVisit')">
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn icon small class="ml-2"
                        @click="removeQuestion('firstVisit', dialogData.questions.firstVisit.selectedIndex)">
                        <v-icon small>mdi-minus</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div class="question-content flex-grow-1">
                    <v-text-field
                      v-model="dialogData.questions.firstVisit.list[dialogData.questions.firstVisit.selectedIndex].scoreTopic"
                      label="評分主題" outlined dense class="mb-4"></v-text-field>
                    <v-text-field
                      v-model="dialogData.questions.firstVisit.list[dialogData.questions.firstVisit.selectedIndex].title"
                      label="題目" outlined dense class="mb-4"></v-text-field>

                    <!-- 答案陣列區塊 -->
                    <div class="answer-array-section mt-4">
                      <div class="d-flex justify-space-between align-center mb-2">
                        <div class="subtitle-1">答案列表</div>
                        <v-btn small color="primary" @click="addAnswer('firstVisit')">
                          <v-icon small left>mdi-plus</v-icon>
                          新增答案
                        </v-btn>
                      </div>

                      <v-card v-for="(answer, index) in getCurrentQuestion('firstVisit').answerArray" 
                             :key="index" 
                             outlined 
                             class="mb-2 pa-2">
                        <div class="d-flex align-center justify-space-between mb-2">
                          <div class="subtitle-2">答案 {{ index + 1 }}</div>
                          <v-btn icon x-small @click="removeAnswer('firstVisit', index)">
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <v-text-field v-model="answer.answer" label="答案內容" outlined dense class="mb-2"></v-text-field>
                        <v-text-field v-model="answer.score" label="評分分數" outlined dense type="number" class="mb-2"></v-text-field>
                        <v-text-field v-model="answer.comment" label="評語" outlined dense class="mb-2"></v-text-field>
                      </v-card>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- 第五頁：術後題目 -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div class="d-flex align-center mb-4" style="justify-content: center;">
                  <div class="text-h6">設定術後題目</div>
                </div>

                <!-- 圖片上傳區域 -->
                <div class="mb-4">
                  <div class="d-flex align-center">
                    <v-file-input v-model="dialogData.questions.postOp.files" multiple chips outlined dense
                      prepend-icon="mdi-upload" class="flex-grow-1" hide-details label="選擇檔案" :show-size="true"
                      accept=".png,.jpg,.jpeg"></v-file-input>
                  </div>
                  <!-- 已上傳圖片 -->
                  <div v-if="isEditing && dialogData.questions.postOp.uploadedFiles.length > 0" class="mt-3">
                    <div class="subtitle-2 mb-2">已上傳圖片</div>
                    <div class="d-flex flex-wrap">
                      <div v-for="(image, index) in dialogData.questions.postOp.uploadedFiles" :key="'po-img-' + index"
                        class="uploaded-image-thumb mr-2 mb-2">
                        <v-img :src="returnImageUrlByType(image, 3)" width="100" height="100"
                          class="rounded" cover @click="showUploadedImageDialog(3, dialogData.questions.postOp.uploadedFiles, dialogData.basicInfo._id)"></v-img>
                        <v-btn icon x-small color="error" class="uploaded-image-delete-btn"
                          @click="confirmDeleteImage(3, image, 'postOp')">
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- 問題列表 -->
                <div class="questions-container">
                  <div class="question-list">
                    <div v-for="(question, index) in dialogData.questions.postOp.list" :key="index"
                      class="question-item" :class="{ selected: dialogData.questions.postOp.selectedIndex === index }"
                      @click="selectQuestion('postOp', index)">
                      題目{{ index + 1 }}
                    </div>
                    <div class="d-flex mt-2" style="justify-content: center;">
                      <v-btn icon small @click="addQuestion('postOp')">
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn icon small class="ml-2"
                        @click="removeQuestion('postOp', dialogData.questions.postOp.selectedIndex)">
                        <v-icon small>mdi-minus</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div class="question-content flex-grow-1">
                    <v-text-field
                      v-model="dialogData.questions.postOp.list[dialogData.questions.postOp.selectedIndex].scoreTopic"
                      label="評分主題" outlined dense class="mb-4"></v-text-field>
                    <v-text-field
                      v-model="dialogData.questions.postOp.list[dialogData.questions.postOp.selectedIndex].title"
                      label="題目" outlined dense class="mb-4"></v-text-field>

                    <!-- 答案陣列區塊 -->
                    <div class="answer-array-section mt-4">
                      <div class="d-flex justify-space-between align-center mb-2">
                        <div class="subtitle-1">答案列表</div>
                        <v-btn small color="primary" @click="addAnswer('postOp')">
                          <v-icon small left>mdi-plus</v-icon>
                          新增答案
                        </v-btn>
                      </div>

                      <v-card v-for="(answer, index) in getCurrentQuestion('postOp').answerArray" 
                             :key="index" 
                             outlined 
                             class="mb-2 pa-2">
                        <div class="d-flex align-center justify-space-between mb-2">
                          <div class="subtitle-2">答案 {{ index + 1 }}</div>
                          <v-btn icon x-small @click="removeAnswer('postOp', index)">
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <v-text-field v-model="answer.answer" label="答案內容" outlined dense class="mb-2"></v-text-field>
                        <v-text-field v-model="answer.score" label="評分分數" outlined dense type="number" class="mb-2"></v-text-field>
                        <v-text-field v-model="answer.comment" label="評語" outlined dense class="mb-2"></v-text-field>
                      </v-card>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- 第六頁：軟性題目 -->

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div class="d-flex align-center mb-4" style="justify-content: center;">
                  <div class="text-h6">設定軟性題目</div>
                </div>

                <!-- 問題列表 -->
                <div class="questions-container">
                  <div class="question-list">
                    <div v-for="(question, index) in dialogData.questions.softQuestion.list" :key="index"
                      class="question-item"
                      :class="{ selected: dialogData.questions.softQuestion.selectedIndex === index }"
                      @click="selectQuestion('softQuestion', index)">
                      題目{{ index + 1 }}
                    </div>
                    <div class="d-flex mt-2" style="justify-content: center;">
                      <v-btn icon small @click="addQuestion('softQuestion')">
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                      <v-btn icon small class="ml-2"
                        @click="removeQuestion('softQuestion', dialogData.questions.softQuestion.selectedIndex)">
                        <v-icon small>mdi-minus</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div class="question-content flex-grow-1">
                    <v-text-field
                      v-model="dialogData.questions.softQuestion.list[dialogData.questions.softQuestion.selectedIndex].title"
                      label="題目" outlined dense class="mb-4"></v-text-field>

                    <v-textarea
                      v-model="dialogData.questions.softQuestion.list[dialogData.questions.softQuestion.selectedIndex].answer"
                      label="答案" outlined rows="4"></v-textarea>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="previousStep" :disabled="dialogData.activeTab === 0">
            上一步
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">
            取消
          </v-btn>
          <v-btn color="primary" @click="nextStep" v-if="dialogData.activeTab < 5">
            下一步
          </v-btn>
          <v-btn color="primary" @click="savePatient" v-else :loading="saving" :disabled="saving">
            儲存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 新增分類 -->
    <v-dialog v-model="showAddDialog" max-width="400">
      <v-card>
        <v-card-title>輸入分類名稱</v-card-title>
        <v-card-text>
          <v-text-field v-model="categoryName" label="分類名稱" outlined dense></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showAddDialog = false">取消</v-btn>
          <v-btn color="primary" @click="handleAddCategory">新增</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 刪除確認 -->
    <v-dialog v-model="showDeleteConfirm" max-width="400">
      <v-card>
        <v-card-title>確定要刪除分類嗎</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDeleteConfirm = false">取消</v-btn>
          <v-btn color="error" @click="confirmDelete">刪除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 以上傳圖片瀏覽對話框 -->
    <v-dialog v-model="uploadedImageDialog.visible" max-width="800">
      <v-card>
        <v-card-title>已上傳圖片</v-card-title>
        <v-carousel>
          <v-carousel-item v-for="(image, index) in uploadedImageDialog.images" :key="index"
            :src="returnImageUrlByType(image, uploadedImageDialog.imageType)">
            <v-btn icon large color="error" class="delete-button" style="position: absolute; top: 0; right: 0;"
              @click="deleteUploadedImageSingle(image)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>

    <!-- 刪除病患確認 -->
    <v-dialog v-model="deletePatientDialog" max-width="400">
      <v-card>
        <v-card-title>確定要刪除此病患嗎？</v-card-title>
        <v-card-text>此操作無法復原。</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deletePatientDialog = false">取消</v-btn>
          <v-btn color="error" @click="confirmDeletePatient">刪除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 新增練習結果對話框 -->
    <v-dialog v-model="showPracticeResults" max-width="1000">
      <v-card>
        <v-card-title class="headline d-flex align-center">
          練習結果列表
          <v-spacer></v-spacer>
          <v-btn color="black" dark @click="exportPracticeResultsCsv" class="mr-2">
            匯出 CSV
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-data-table :headers="practiceHeaders" :items="practiceResults" hide-default-footer class="elevation-0">
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-left">{{ formatDateTime(item.uploadTime) }}</td>
                <td class="text-left">{{ item.student?.name || '未知學生' }}</td>
                <td class="text-left">{{ item.examScore || 0 }}</td>
                <td class="text-center">
                  <v-btn small text color="primary" @click="showAnswerDetail(item)" class="mr-2">
                    <v-icon small class="mr-1">mdi-file-document-outline</v-icon>
                    答題過程
                  </v-btn>
                  <v-btn small text color="primary" @click="viewScoreSheet(item)">
                    <v-icon small class="mr-1">mdi-file-check-outline</v-icon>
                    評分表
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="showPracticeResults = false">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 答題過程查看對話框 -->
    <exam-answer-viewer v-model="showAnswerViewer" :exam-result="selectedExamResult" :student-answer="studentAnswer" />

    <!-- 評分表對話框 -->
    <v-dialog v-model="showScoreSheet" width="1000">
      <editable-score-sheet :exam-data="examData" @save="handleSave" @export-csv="handleExportCSV"
        @close="handleClose" />
    </v-dialog>

    <!-- 訊息提示 -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">關閉</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import PatientCategoryService from '@/services/patientCategory.service';
import TagCategoryService from '@/services/tagCategory.service';
import PatientService from '@/services/patient.service';
import TagCategoryTopicService from '@/services/tagCategoryTopic.service';
import ExamResultService from '@/services/examResult.service';
import ExamAnswerViewer from '@/components/ExamAnswerViewer.vue';
import EditableScoreSheet from '@/components/EditableScoreSheet.vue';
import baseUrl from '../../../baseUrl.config';
export default {
  name: 'PatientManagement',
  components: {
    ExamAnswerViewer,
    EditableScoreSheet
  },
  data() {
    return {

      search: '',
      languageOptions: [
        { text: '中文', value: 'zh' },
        { text: '英文', value: 'en' },
        { text: '越南文', value: 'vi' },
        { text: '印尼文', value: 'id' }
      ],
      selectedPatient: null,
      isEditingTag: false,
      isEditing: false,
      editingPatient: null,
      tagCategoryTopics: [],
      patientCategorys: [],
      selectedPatientCategories: [],
      uploadedImageDialog: {
        visible: false,
        images: [],
        imageType: 0,
        nowPatient_id: null
      },
      patients: [],
      // departments: [
      //   {
      //     id: '1',
      //     name: '牙醫科',
      //     patients: [
      //       { 
      //         id: '1', 
      //         name: 'Amy Chen', 
      //         age: 40, 
      //         gender: '女', 
      //         isVisible: true,
      //         backgroundImage: require('@/assets/patient-bg.jpg')  // 使用 require 來引入圖片
      //       },
      //       { id: '2', name: 'John Doe', age: 35, gender: '男', isVisible: true, backgroundImage: '@/assets/patient-bg.jpg' },
      //       { id: '3', name: 'Mary Wang', age: 28, gender: '女', isVisible: true, backgroundImage: '@/assets/patient-bg.jpg' },
      //       { id: '4', name: 'Tom Lee', age: 45, gender: '男', isVisible: true, backgroundImage: '@/assets/patient-bg.jpg' },
      //     ]
      //   },
      //   {
      //     id: '2',
      //     name: '心臟科',
      //     patients: [
      //       { id: '5', name: 'Amy Chen', age: 40, gender: '女', isVisible: true, backgroundImage: '@/assets/patient-bg.jpg' },
      //       { id: '6', name: 'David Wu', age: 52, gender: '男', isVisible: true, backgroundImage: '@/assets/patient-bg.jpg' },
      //       { id: '7', name: 'Sarah Lin', age: 33, gender: '女', isVisible: true, backgroundImage: '@/assets/patient-bg.jpg' },
      //       { id: '8', name: 'Mike Chen', age: 48, gender: '男', isVisible: true, backgroundImage: '@/assets/patient-bg.jpg' },
      //     ]
      //   }
      // ],

      tabs: [
        { title: '選擇標籤' },
        { title: '基本資料' },
        { title: '面診題目' },
        { title: '初診題目' },
        { title: '術後題目' },
        { title: '軟性題目' }
      ],
      tagsCategory: [
      ],
      saving: false,
      snackbar: {
        show: false,
        message: '',
        color: 'error',
        timeout: 5000
      },
      dialog: false,
      dialogData: {
        activeTab: 0,
        tags: [],
        tagCategoryTopic: null,
        basicInfo: {
          name: '',
          age: '',
          gender: '',
          language: 'zh',
          patientCategory: null,
          description: '',
          taskDescription: '',
          image: null
        },
        questions: {
          clinic: {
            selectedIndex: 0,
            list: [
              { title: '題目一', answer: '答案一', scoreTopic: '', score: '', comment: '' }
            ],
            files: [],
            uploadedFiles: []
          },
          firstVisit: {
            selectedIndex: 0,
            list: [
              { title: '', answer: '', scoreTopic: '', score: '', comment: '' }
            ],
            files: [],
            uploadedFiles: []
          },
          postOp: {
            selectedIndex: 0,
            list: [
              { title: '', answer: '', scoreTopic: '', score: '', comment: '' }
            ],
            files: [],
            uploadedFiles: []
          },
          softQuestion: {
            selectedIndex: 0,
            list: [
              { title: '', answer: '' }
            ],
          }
        }
      },
      showAddDialog: false,
      showDeleteConfirm: false,
      categoryName: '',
      categoryToDelete: null,
      deletePatientDialog: false,
      patientToDelete: null,
      showPracticeResults: false,
      practiceResults: [],
      practiceHeaders: [
        { text: '完成時間', value: 'uploadTime', width: '25%' },
        { text: '學生姓名', value: 'student.name', width: '25%' },
        { text: '分數', value: 'examScore', width: '20%' },
        { text: '操作', value: 'actions', sortable: false, width: '30%' }
      ],
      showAnswerViewer: false,
      selectedExamResult: {},
      studentAnswer: {},
      showScoreSheet: false,
      examData: null
    }
  },
  mounted() {
    // this.getPatientCategoryBySchool()
    this.getTagCategoryBySchool()
    this.getTagCategoryTopicBySchool()
    this.getPatientSortByTagCategoryTopic()
  },
  methods: {
    getPatientSortByTagCategoryTopic() {
      PatientService.getPatientSortByTagCategoryTopic().then((res) => {
        this.patients = res.data.data
      })
    },
    getTagCategoryTopicBySchool() {
      TagCategoryTopicService.getBySchool().then((res) => {
        this.tagCategoryTopics = res.data.data
      })
    },
    showUploadedImageDialog(type, images, patientId) {
      this.uploadedImageDialog.visible = true;
      this.uploadedImageDialog.images = images;
      this.uploadedImageDialog.imageType = type;
      this.uploadedImageDialog.nowPatient_id = patientId;
    },
    confirmDeleteImage(imageType, image, questionKey) {
      if (!confirm('確定要刪除此圖片嗎？')) return
      const patientId = this.dialogData.basicInfo._id
      PatientService.deleteUploadedImageSingle(patientId, imageType, image).then(() => {
        const arr = this.dialogData.questions[questionKey].uploadedFiles
        const idx = arr.indexOf(image)
        if (idx !== -1) arr.splice(idx, 1)
        this.showSnackbar('圖片刪除成功', 'success')
      }).catch(() => {
        this.showSnackbar('圖片刪除失敗，請稍後再試', 'error')
      })
    },
    deleteUploadedImageSingle(image) {
      if (!confirm('確定要刪除此圖片嗎？')) return
      const typeToKey = { 1: 'clinic', 2: 'firstVisit', 3: 'postOp' }
      const questionKey = typeToKey[this.uploadedImageDialog.imageType]
      PatientService.deleteUploadedImageSingle(this.uploadedImageDialog.nowPatient_id, this.uploadedImageDialog.imageType, image).then(() => {
        if (questionKey) {
          const arr = this.dialogData.questions[questionKey].uploadedFiles
          const idx = arr.indexOf(image)
          if (idx !== -1) arr.splice(idx, 1)
        }
        this.uploadedImageDialog.images = this.uploadedImageDialog.images.filter(img => img !== image)
        this.showSnackbar('圖片刪除成功', 'success')
      }).catch(() => {
        this.showSnackbar('圖片刪除失敗，請稍後再試', 'error')
      })
    },
    updatePatientStatus(patientId, isActive) {
      PatientService.updatePatientStatus(patientId, isActive).then(() => {
        this.getPatientCategoryBySchool()
      })
    },
    // async getPatientCategoryBySchool() {
    //   try {
    //     const res = await PatientCategoryService.getBySchool()
    //     this.patientCategorys = res.data.data
    //     if(this.patientCategorys.length > 0){
    //       for(let i = 0; i < this.patientCategorys.length; i++){
    //         const patients = await this.getPatientByCategory(this.patientCategorys[i]._id)
    //         this.$set(this.patientCategorys[i], 'patients', patients)
    //       }
    //     }
    //   } catch (error) {
    //     console.error('Error fetching categories:', error)
    //     this.patientCategorys = []
    //   }
    // },
    getTagCategoryBySchool() {
      TagCategoryService.getBySchool().then((res) => {
        this.tagsCategory = res.data
      })
    },
    async getPatientByCategory(categoryId) {
      try {
        const res = await PatientService.getByCategory(categoryId)
        return Array.isArray(res.data.data) ? res.data.data : []
      } catch (error) {
        console.error('Error fetching patients for category', categoryId, ':', error)
        return []
      }
    },
    addPatient() {
      this.isEditing = false;
      this.editingPatient = null;
      this.resetDialogData();
      this.dialog = true;
    },
    toggleTag(tag) {
      const index = this.dialogData.tags.indexOf(tag)
      if (index === -1) {
        this.dialogData.tags.push(tag)
      } else {
        this.dialogData.tags.splice(index, 1)
      }
    },
    resetDialogData() {
      this.dialogData = {
        activeTab: 0,
        tags: [],
        basicInfo: {
          name: '',
          age: '',
          gender: '',
          language: 'zh',
          patientCategory: null,
          tagCategoryTopic: null,
          description: '',
          taskDescription: '',
          image: null
        },
        questions: {
          clinic: {
            selectedIndex: 0,
            list: [
              { title: '題目一', answer: '答案一', scoreTopic: '', score: '', comment: '' }
            ],
            files: [],
            uploadedFiles: []
          },
          firstVisit: {
            selectedIndex: 0,
            list: [
              { title: '', answer: '', scoreTopic: '', score: '', comment: '' }
            ],
            files: [],
            uploadedFiles: []
          },
          postOp: {
            selectedIndex: 0,
            list: [
              { title: '', answer: '', scoreTopic: '', score: '', comment: '' }
            ],
            files: [],
            uploadedFiles: []
          },
          softQuestion: {
            selectedIndex: 0,
            list: [
              { title: '', answer: '' }
            ],
          }
        }
      }
    },
    savePatient() {
      if (this.dialogData.basicInfo.name === '') {
        alert('請輸入病患姓名')
        return
      }
      if (this.dialogData.basicInfo.age === '') {
        alert('請輸入病患年齡')
        return
      }
      if (this.dialogData.basicInfo.gender === '') {
        alert('請輸入病患性別')
        return
      }
      if (this.dialogData.basicInfo.tagCategoryTopic === null) {
        alert('請選擇術式主題')
        return
      }
      if (this.dialogData.basicInfo.description === '') {
        alert('請輸入病患描述')
        return
      }
      if (this.dialogData.basicInfo.taskDescription === '') {
        alert('請輸入任務說明')
        return
      }
      if (this.dialogData.basicInfo.image === null) {
        alert('請上傳病患照片')
        return
      }
      if (this.dialogData.tags.length === 0) {
        alert('請選擇病患標籤')
        return
      }

      if (this.dialogData.questions.clinic.list[0].title === '') {
        alert('請至少輸入一個面診題目')
        return
      }
      if (this.dialogData.questions.clinic.list[0].scoreTopic === '') {
        alert('請至少輸入一個面診題目分數主題')
        return
      }



      const patientFormData = new FormData()

      if (this.dialogData.questions.firstVisit.list[0].title === '') {
        patientFormData.append('firstVisitQuestionExist', false)
      } else {
        patientFormData.append('firstVisitQuestionExist', true)
      }
      if (this.dialogData.questions.postOp.list[0].title === '') {
        patientFormData.append('postOpQuestionExist', false)
      } else {
        patientFormData.append('postOpQuestionExist', true)
      }
      if (this.dialogData.questions.softQuestion.list[0].title === '') {
        patientFormData.append('softQuestionExist', false)
      } else {
        patientFormData.append('softQuestionExist', true)
      }

      // Don't JSON.stringify primitive values
      patientFormData.append('name', this.dialogData.basicInfo.name)
      patientFormData.append('age', this.dialogData.basicInfo.age)
      patientFormData.append('gender', this.dialogData.basicInfo.gender)
      patientFormData.append('language', this.dialogData.basicInfo.language || 'zh')

      patientFormData.append('tagCategoryTopic', this.dialogData.basicInfo.tagCategoryTopic)
      // For objects and arrays, use JSON.stringify
      patientFormData.append('patientCategory', JSON.stringify(this.dialogData.basicInfo.patientCategory))
      patientFormData.append('description', this.dialogData.basicInfo.description)
      patientFormData.append('taskDescription', this.dialogData.basicInfo.taskDescription)
      // For files, append each file individually
      if (this.dialogData.basicInfo.image) {
        // Convert base64 to blob if image is base64 string
        if (this.dialogData.basicInfo.image.startsWith('data:')) {
          const blob = this.base64ToBlob(this.dialogData.basicInfo.image)
          patientFormData.append('backgroundImage', blob, 'image.jpg')
        } else {
          patientFormData.append('backgroundImage', this.dialogData.basicInfo.image)
        }
      }

      patientFormData.append('tags', JSON.stringify(this.dialogData.tags))
      patientFormData.append('clinicQuestions', JSON.stringify(this.dialogData.questions.clinic.list))
      patientFormData.append('firstVisitQuestions', JSON.stringify(this.dialogData.questions.firstVisit.list))
      patientFormData.append('postOpQuestions', JSON.stringify(this.dialogData.questions.postOp.list))
      patientFormData.append('softQuestions', JSON.stringify(this.dialogData.questions.softQuestion.list))
      // For file arrays, append each file individually
      this.dialogData.questions.clinic.files.forEach((file) => {
        patientFormData.append(`clinicFiles`, file)
      })
      this.dialogData.questions.firstVisit.files.forEach((file) => {
        patientFormData.append(`firstVisitFiles`, file)
      })
      this.dialogData.questions.postOp.files.forEach((file) => {
        patientFormData.append(`postOpFiles`, file)
      })

      this.saving = true
      if (this.isEditing) {
        patientFormData.append('_id', this.editingPatient._id)
        PatientService.update(patientFormData).then(() => {
          this.getPatientSortByTagCategoryTopic()
          this.closeDialog()
          this.showSnackbar('虛擬病患更新成功', 'success')
        }).catch((err) => {
          const msg = (err.response && err.response.data && err.response.data.message) || '更新虛擬病患失敗，請稍後再試'
          this.showSnackbar(msg, 'error')
        }).finally(() => {
          this.saving = false
        })
      } else {
        PatientService.add(patientFormData).then(() => {
          this.getPatientSortByTagCategoryTopic()
          this.closeDialog()
          this.showSnackbar('虛擬病患新增成功', 'success')
        }).catch((err) => {
          const msg = (err.response && err.response.data && err.response.data.message) || '新增虛擬病患失敗，請稍後再試'
          this.showSnackbar(msg, 'error')
        }).finally(() => {
          this.saving = false
        })
      }
    },
    showSnackbar(message, color = 'error') {
      this.snackbar.message = message
      this.snackbar.color = color
      this.snackbar.show = true
    },
    closeDialog() {
      this.dialog = false;
      this.isEditing = false;
      this.editingPatient = null;
      this.resetDialogData();
    },
    nextStep() {
      if (this.dialogData.activeTab < 5) {
        this.dialogData.activeTab++
      }
    },
    previousStep() {
      if (this.dialogData.activeTab > 0) {
        this.dialogData.activeTab--
      }
    },
    uploadImage() {
      console.log('上傳圖片')
    },
    generateAI() {
      console.log('AI 生成')
    },
    addQuestion(type) {
      const questions = this.dialogData.questions[type].list
      questions.push({
        title: `問題${questions.length + 1}`,
        answer: '',
        scoreTopic: '',
        score: '',
        comment: ''
      })
    },
    removeQuestion(type) {
      const questions = this.dialogData.questions[type].list;
      const currentIndex = this.dialogData.questions[type].selectedIndex;

      // 確保至少保留一個題目
      if (questions.length > 1) {
        // 刪除當前選中的題目
        questions.splice(currentIndex, 1);

        // 更新 selectedIndex
        if (currentIndex >= questions.length) {
          // 如果刪除的是最後一個題目，選中新的最後一個
          this.dialogData.questions[type].selectedIndex = questions.length - 1;
        } else {
          // 保持當前索引（會自動指向下一個題目）
          this.dialogData.questions[type].selectedIndex = currentIndex;
        }
      } else {
        // 如果只剩一個題目，給出提示
        alert('至少需要保留一個題目');
      }
    },
    selectQuestion(type, index) {
      this.dialogData.questions[type].selectedIndex = index
    },
    // 新增分類
    handleAddCategory() {
      PatientCategoryService.add({
        name: this.categoryName
      }).then(() => {
        this.getPatientCategoryBySchool()
        this.categoryName = ''
        this.showAddDialog = false
      })
    },
    // 開啟刪除確認
    openDeleteConfirm() {
      console.log(this.selectedPatientCategories)
      this.categoryToDelete = this.selectedPatientCategories
      this.showDeleteConfirm = true
    },

    // 確認刪除
    confirmDelete() {
      PatientCategoryService.delete(this.categoryToDelete).then(() => {
        this.getPatientCategoryBySchool()
        this.selectedPatientCategories = []
        this.showDeleteConfirm = false
        this.categoryToDelete = null
      })
    },
    editPatient(patient) {
      this.isEditing = true;
      this.editingPatient = patient;
      // 填充表單數據
      this.dialogData = {
        activeTab: 0,
        tags: patient.tags || [],
        basicInfo: {
          _id: patient._id,
          name: patient.name,
          age: patient.age,
          gender: patient.gender,
          language: patient.language || 'zh',
          tagCategoryTopic: patient.tagCategoryTopic._id,
          patientCategory: patient.patientCategory,
          description: patient.description || '',
          taskDescription: patient.taskDescription || '',
          image: this.returnImageUrl(patient.backgroundImage)
        },
        questions: {
          clinic: {
            selectedIndex: 0,
            list: patient.clinicQuestions || [{ title: '問題1', answer: '' }],
            files: [],
            uploadedFiles: patient.clinicFiles || []
          },
          firstVisit: {
            selectedIndex: 0,
            list: patient.firstVisitQuestions || [{ title: '', answer: '' }],
            files: [],
            uploadedFiles: patient.firstVisitFiles || []
          },
          postOp: {
            selectedIndex: 0,
            list: patient.postOpQuestions || [{ title: '', answer: '' }],
            files: [],
            uploadedFiles: patient.postOpFiles || []
          },
          softQuestion: {
            selectedIndex: 0,
            list: patient.softQuestions || [{ title: '', answer: '' }],
          }
        }
      };
      console.log(this.dialogData)
      this.dialog = true;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // 將檔案轉換為 base64
        const reader = new FileReader();
        reader.onload = (e) => {
          this.dialogData.basicInfo.image = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    removeBackgroundImage() {
      this.dialogData.basicInfo.image = null
    },
    handleVoiceInput() {
      console.log('語音輸入')
    },
    // Add helper method for base64 to blob conversion
    base64ToBlob(base64) {
      const parts = base64.split(';base64,')
      const contentType = parts[0].split(':')[1]
      const raw = window.atob(parts[1])
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }

      return new Blob([uInt8Array], { type: contentType })
    },
    returnImageUrl(imageUrl) {
      return baseUrl + "uploadFiles/backgroundImage/" + imageUrl
    },
    returnImageUrlByType(imageUrl, type) {
      switch (type) {
        case 0:
          return baseUrl + "uploadFiles/backgroundImage/" + imageUrl
        case 1:
          return baseUrl + "uploadFiles/clinicFiles/" + imageUrl
        case 2:
          return baseUrl + "uploadFiles/firstVisitFiles/" + imageUrl
        case 3:
          return baseUrl + "uploadFiles/postOpFiles/" + imageUrl
      }
    },
    deletePatient(patient) {
      this.patientToDelete = patient;
      this.deletePatientDialog = true;
    },
    confirmDeletePatient() {
      PatientService.delete(this.patientToDelete._id).then(() => {
        this.getPatientSortByTagCategoryTopic();
        this.deletePatientDialog = false;
        this.patientToDelete = null;
      });
    },
    async viewPracticeResults(patient) {
      this.selectedPatient = patient;
      try {
        const response = await ExamResultService.teacherGetPatientResult(patient._id);
        this.practiceResults = response.data.data;
        this.showPracticeResults = true;
      } catch (error) {
        console.error('Error fetching practice results:', error);
      }
    },
    formatDateTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    showAnswerDetail(result) {
      ExamResultService.teacherGetExamResultDetail(result._id).then((res) => {
        this.selectedExamResult = res.data.data.patient;
        this.studentAnswer = {
          messages: res.data.data.exam_result_id.messages,
          answers: res.data.data.exam_result_id.answerData[0]
        };
        this.showAnswerViewer = true;
      });
    },
    viewScoreSheet(result) {
      ExamResultService.teacherGetExamResultDetail(result._id).then((res) => {
        this.examData = res.data.data;
        this.showScoreSheet = true;
      });
    },
    async handleSave(updatedData) {
      try {
        await ExamResultService.updateExamResult(updatedData._id, updatedData);
        this.showScoreSheet = false;
        // 重新載入練習結果
        if (this.selectedPatient) {
          this.viewPracticeResults(this.selectedPatient);
        }
      } catch (error) {
        console.error('儲存失敗:', error);
      }
    },
    handleClose() {
      this.showScoreSheet = false;
    },
    handleExportCSV() {
      // This method will be called when the score sheet component emits the export-csv event
      // The actual CSV export is handled by the score sheet component
    },
    exportPracticeResultsCsv() {
      // 準備 CSV 內容
      const headers = [
        '完成時間',
        '學生姓名',
        '分數'
      ];

      let csvContent = headers.join(',') + '\n';

      // 添加每個練習的資料
      this.practiceResults.forEach(result => {
        const row = [
          this.formatDateTime(result.uploadTime),
          result.student?.name || '',
          result.examScore || 0
        ].map(field => `"${field}"`).join(',');

        csvContent += row + '\n';
      });

      // 添加 BOM 以確保 Excel 正確顯示中文
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const fileName = `練習結果_${this.selectedPatient?.name || '未命名'}_${new Date().toLocaleDateString()}.csv`;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    getCurrentQuestion(type) {
      const questions = this.dialogData.questions[type];
      const currentQuestion = questions.list[questions.selectedIndex];
      if (!currentQuestion.answerArray) {
        this.$set(currentQuestion, 'answerArray', []);
      }
      return currentQuestion;
    },
    addAnswer(type) {
      const currentQuestion = this.getCurrentQuestion(type);
      currentQuestion.answerArray.push({
        answer: '',
        score: '',
        comment: ''
      });
    },
    removeAnswer(type, index) {
      const currentQuestion = this.getCurrentQuestion(type);
      currentQuestion.answerArray.splice(index, 1);
    }
  },
  computed: {
    filteredPatientCategories() {
      if (!this.search) {
        return this.patients;
      }

      const searchTerm = this.search.toLowerCase().trim();

      return this.patients.filter(category => {
        // 檢查分類名稱是否符合搜尋條件
        const categoryMatch = category.topicName.toLowerCase().includes(searchTerm);

        // 檢查該分類下的病患是否符合搜尋條件
        const hasMatchingPatients = category.patients?.some(patient =>
          patient.name?.toLowerCase().includes(searchTerm)
        );

        // 如果分類名稱或任何病患符合搜尋條件，就回傳該分類
        return categoryMatch || hasMatchingPatients;
      }).map(category => {
        // 在這裡重新檢查分類名稱是否符合
        const categoryMatch = category.topicName.toLowerCase().includes(searchTerm);

        return {
          ...category,
          // 如果分類名稱符合，顯示所有病患；否則只顯示符合搜尋條件的病患
          patients: categoryMatch ?
            category.patients :
            category.patients?.filter(patient =>
              patient.name?.toLowerCase().includes(searchTerm)
            )
        };
      });
    },
    filteredTagsCategory() {
      if (!this.dialogData.basicInfo.tagCategoryTopic) {
        return []; // 如果沒有選擇術式主題，返回空數組
      }
      return this.tagsCategory.filter(category => {
        if (category.tagCategoryTopic) {
          return category.tagCategoryTopic._id === this.dialogData.basicInfo.tagCategoryTopic
        }
        return false
      }
      );
    }
  }
}
</script>

<style scoped>
.patient-card {
  transition: all 0.3s;
  height: 250px;
  position: relative;
  overflow: hidden;
}

.patient-card .v-card__text {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.patient-info {
  margin-top: auto;
  text-align: left;
}

.patient-card-content {
  padding-right: 0px;
}

.v-switch ::v-deep .v-input__control {
  width: 40px;
}

.patient-card-switch {
  margin-top: 0px;
  margin-right: 0px;
}

.patient-card.selected {
  border: 2px solid #fff;
}

.patient-card:hover {
  opacity: 0.8;
}

.v-tabs {
  margin-bottom: 20px;
}

.black-bg {
  background-color: black;
  border-radius: 4px;
}

.question-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}

.questions-container {
  margin-top: 20px;
  display: flex;
  gap: 20px;
}

.question-list {
  width: 120px;
}

.question-item {
  padding: 8px 12px;
  margin-bottom: 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.question-item:hover {
  background-color: #f5f5f5;
}

.question-item.selected {
  background-color: #e0e0e0;
}

.question-content {
  flex: 1;
}

.upload-container {
  background-color: black;
  width: 600px;
  height: 400px;
  border-radius: 4px;
  padding: 0;
  margin: 0px 20px 20px 20px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.preview-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bg-image-delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.85) !important;
}

.button-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 10px;
  z-index: 1;
}

.image-button {
  width: 100px;
  background: rgba(0, 0, 0, 0.5) !important;
}

.patient-card-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  /* 確保背景在內容之下 */
}

.patient-card-content {
  position: relative;
  z-index: 1;
  /* 確保內容在背景之上 */
  background: rgba(0, 0, 0, 0.5);
  /* 半透明黑色遮罩 */
  height: 100%;
}

.uploaded-image-thumb {
  position: relative;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.uploaded-image-thumb:hover .uploaded-image-delete-btn {
  opacity: 1;
}

.uploaded-image-delete-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(255, 255, 255, 0.9) !important;
  opacity: 0;
  transition: opacity 0.2s;
}
</style>
